import { __assign, __makeTemplateObject, __read, __rest } from "tslib";
import { css, cx } from 'emotion';
import { useField, useFormikContext } from 'formik';
import React, { Fragment } from 'react';
import Datetime from 'react-datetime';
export var DateField = function (_a) {
    var name = _a.name, label = _a.label, _b = _a.dateFormat, dateFormat = _b === void 0 ? 'YYYY-MM-DD' : _b, dateControlProps = __rest(_a, ["name", "label", "dateFormat"]);
    var setFieldValue = useFormikContext().setFieldValue;
    var _c = __read(useField(name), 1), field = _c[0];
    return (React.createElement(Fragment, null,
        React.createElement("div", { key: field.name, className: cx('col', css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            flex-direction: column;\n            display: inline-grid;\n          "], ["\n            flex-direction: column;\n            display: inline-grid;\n          "])))) },
            React.createElement("label", null, label),
            React.createElement(Datetime, __assign({}, field, dateControlProps, { value: (field.value && new Date(field.value)) || null, onChange: function (val) {
                    if (field.value !== val) {
                        if (typeof val === 'string') {
                            setFieldValue(field.name, val);
                        }
                        else {
                            setFieldValue(field.name, val.format(dateFormat));
                        }
                    }
                }, closeOnSelect: true, dateFormat: dateFormat, timeFormat: false })))));
};
var templateObject_1;
//# sourceMappingURL=DateField.js.map